var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubAdvisorConsentForm',{attrs:{"subAdvisorPmData":_vm.subAdvisorPmData,"clientId":_vm.clientId},on:{"after-submit":_vm.afterSubmit,"disagree":_vm.onDisagree}})
}
var staticRenderFns = []

export { render, staticRenderFns }